
<mat-spinner style="margin: 0; position: absolute; top: calc(50% - 50px); right: calc(50% - 50px); -ms-transform: translateY(-50%); transform: translateY(-50%); "></mat-spinner>
